import { useEffect } from "react";
import { useAtom, useSetAtom } from "jotai";
import { Alert } from "../Common/Alert";
import { Toast } from "../Common/Toast";
import { notificationsAtom, removeNotificationAtom } from "./store/notificationAtoms";

export const Notification = () => {
    const [notifications] = useAtom(notificationsAtom);
    const removeNotification = useSetAtom(removeNotificationAtom);

    const positionClasses: Record<
        string,
        { x: "start" | "center" | "end"; y: "top" | "middle" | "bottom" }
    > = {
        "top-start": { x: "start", y: "top" },
        "top-center": { x: "center", y: "top" },
        "top-end": { x: "end", y: "top" },
        "bottom-start": { x: "start", y: "bottom" },
        "bottom-center": { x: "center", y: "bottom" },
        "bottom-end": { x: "end", y: "bottom" },
    };

    useEffect(() => {
        const timers = notifications
            .filter(
                (notification) =>
                    typeof notification.interval === "number" && notification.interval > 0,
            )
            .map((notification) =>
                setTimeout(() => {
                    removeNotification(notification.id);
                }, notification.interval as number),
            );

        return () => {
            timers.forEach((timer) => clearTimeout(timer));
        };
    }, [notifications, removeNotification]);

    if (notifications.length === 0) {
        return null;
    }

    const groupedByPosition = notifications.reduce(
        (acc, notification) => {
            const position = notification.position || "top-end";
            if (!acc[position]) {
                acc[position] = [];
            }
            acc[position].push(notification);
            return acc;
        },
        {} as Record<string, typeof notifications>,
    );

    return (
        <>
            {Object.entries(groupedByPosition).map(([position, positionNotifications]) => {
                return (
                    <Toast
                        key={position}
                        x={positionClasses[position].x}
                        y={positionClasses[position].y}
                        className="z-50"
                    >
                        {positionNotifications.map((notification) => (
                            <div key={notification.id}>
                                <Alert
                                    color={notification.color}
                                    title={notification.title}
                                    onClose={() => removeNotification(notification.id)}
                                >
                                    {notification.message}
                                </Alert>
                            </div>
                        ))}
                    </Toast>
                );
            })}
        </>
    );
};

export default Notification;
